import {Directive, Input, TemplateRef} from '@angular/core';

/**
 *
 */
@Directive({
  // tslint:disable-next-line: directive-selector
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appCustomHint]'
})
export class CustomHintDirective {
  @Input() hintClass = 'hint d-flex';
  @Input() showDefaultIcon = true;
  constructor(public templateRef: TemplateRef<unknown>) {}
}
